<template>
    <div ref="EcRef" class="echart-canvas"></div>
</template>

<script>
    import echarts from 'echarts/lib/echarts'
    import 'echarts/lib/chart/bar'
    import 'echarts/lib/component/tooltip'
    import 'echarts/lib/component/legend'
    import 'echarts/lib/component/title'

    export default {
        name: "EC-CANVAS",
        props: {
            zcb: [String, Number],
            zsy: [String, Number],
        },
        data() {
            return {
                chart: null,
                timer: null
            }
        },
        components: {},
        watch: {
            zcb(val) {
                if (this.timer) {
                    clearTimeout(this.timer)
                }
                this.timer = setTimeout(() => {
                    this.init()
                }, 400)
            },
            zsy(val) {
                if (this.timer) {
                    clearTimeout(this.timer)
                }
                this.timer = setTimeout(() => {
                    this.init()
                }, 400)
            }
        },
        created() {
        },
        mounted() {
            this.chart = echarts.init(this.$refs.EcRef)
            this.init()
            window.addEventListener("resize", () => {
                this.chart.resize()
            })
        },
        methods: {
            init() {
                let xData = [0]
                let yData = [0]
                const zsy = Number(this.zsy)
                const pj = zsy / 12
                for (let i = 1; i <= 12; i++) {
                    xData.push(i)
                    yData.push((pj * i).toFixed(2))
                }

                this.chart.setOption({
                    backgroundColor: 'transparent',
                    color: ['#009acd', '#f7bb00'],
                    tooltip: {
                        formatter: '{a}：{c}元'
                    },
                    legend: {
                        data: ['收益', '投资'],
                        bottom: 10
                    },
                    grid: {
                        left: '3%',
                        right: '3%',
                        bottom: 40,
                        containLabel: true
                    },
                    xAxis: {
                        data: xData,
                    },
                    yAxis: {
                        name: '人民币元',
                    },
                    series: [
                        {
                            name: '收益',
                            type: 'bar',
                            data: yData,
                            stack: '收益',
                        },
                        {
                            name: '投资',
                            type: 'bar',
                            stack: '收益',
                            data: [-this.zcb],
                            itemStyle: {},

                        }
                    ]
                })
            }
        },
    }
</script>

<style lang="scss">
    .echart-canvas {
        width: 100%;
        height: 100%;
    }
</style>
